import {
  SET_SCRIPT_VERSION_LIST,
  SET_SCRIPT_VERSION_LIST_PAGE,
  SET_SCRIPT_VERSION_LIST_PAGE_TOTAL,
  SET_SCRIPT_VERSION_LIST_PAGE_SIZE,
  SET_PLATFORM_LIST,
  SET_SCRIPT_VERSION_QUERY,
} from './mutation-types'
import api from '@/api'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
})

const state = {
  platformList: [],
  initQuery: initQuery(),
  scriptVersion: {
    // listCurrentPage: 1,
    // listPageSize: 50,
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_SCRIPT_VERSION_LIST] (state, payload) {
    state.scriptVersion.list = payload
  },
  [SET_SCRIPT_VERSION_LIST_PAGE] (state, payload) {
    state.scriptVersion.query.pageNum = payload
  },
  [SET_SCRIPT_VERSION_LIST_PAGE_TOTAL] (state, payload) {
    state.scriptVersion.listPageTotal = payload
  },
  [SET_SCRIPT_VERSION_LIST_PAGE_SIZE] (state, payload) {
    state.scriptVersion.query.pageSize = payload
  },
  [SET_SCRIPT_VERSION_QUERY] (state, payload) {
    state.scriptVersion.query = payload
  },
  [SET_PLATFORM_LIST] (state, payload) {
    state.platformList = payload
  },
}

const actions = {
  // 获取渲染脚本列表
  async getScriptVersionList ({commit, state, dispatch}, payload) {
    let param = {
      ...payload,
      ...state.scriptVersion.query,
    }
    await dispatch('getPlatform')
    const {data} = await api.deployApi.getScriptVersionList(param)
    if (data !== null && data !== undefined) {
      data.items.forEach(ele => {
        ele.usedPlatformArr = []
        let usedPlatformArrNo = ele.usedPlatform.split(',')
        let usedPlatformArr = state.platformList.filter(e => usedPlatformArrNo.includes(e.platformNo.toString()))
        ele.usedPlatformArr = usedPlatformArr
      })
      commit(SET_SCRIPT_VERSION_LIST_PAGE_TOTAL, data.total)
      commit(SET_SCRIPT_VERSION_LIST_PAGE_SIZE, data.size)
      commit(SET_SCRIPT_VERSION_LIST_PAGE, data.pageNum)
      commit(SET_SCRIPT_VERSION_LIST, data.items)
    }
  },
  changeQuery ({commit}, payload) {
    commit(SET_SCRIPT_VERSION_QUERY, payload)
  },
  // 获取所有平台
  async getPlatform ({commit}) {
    const {data} = await api.nodeApi.getPlatform()
    commit(SET_PLATFORM_LIST, data)
  },
  // 应用
  async applyScript ({dispatch}, payload) {
    const data = await api.deployApi.applyScript(payload)
    if (data.code === 200) {
      dispatch('getScriptVersionList')
    }
    return data
  },
  // 正在应用其他版本的平台
  // eslint-disable-next-line
  async getUsedVersion ({}, payload) {
    const data = await api.deployApi.getUsedVersion(payload)
    return data
  },
  // 编辑脚本
  async saveScript ({dispatch}, payload) {
    const data = await api.deployApi.saveScript(payload)
    if (data.code === 200) {
      dispatch('getScriptVersionList')
    }
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
